import Vue from 'vue';

import { 勘定科目ListItemResponse } from '@/openapi/user';

type State = {
  pksCannotUpdateOrder: number[];
};

const state = Vue.observable<State>({
  pksCannotUpdateOrder: [],
});

export default Vue.extend({
  name: 'M勘定科目UpdateOrderCheckerMixin',

  methods: {
    setPksCannotUpdateOrder(listItems: 勘定科目ListItemResponse[]): void {
      state.pksCannotUpdateOrder = [];
      let prev: 勘定科目ListItemResponse | undefined;
      listItems.forEach((listItem) => {
        if (prev?.c大分類 !== listItem.c大分類 || prev?.c中分類 !== listItem.c中分類)
          state.pksCannotUpdateOrder.push(listItem.pk);
        prev = listItem;
      });
    },
    canUpdateOrder(pk: number): boolean {
      return !state.pksCannotUpdateOrder.includes(pk);
    },
  },
});
